<template>
    <div class="flex items-center space-x-1 w-full mt-4 sm:mt-0 sm:w-48">
        <Listbox as="div" v-model="selected"
                 @update:modelValue="$emit('modelValue', $event)"
                 class="flex flex-column sm:flex-row items-center w-full">
            <div class="relative w-full">
                <ListboxButton
                    class="relative w-full bg-white border border-cyan-900 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-cyan-500 focus:border-cyan-500 sm:text-sm">
                    <span class="block truncate">{{ selected.name }}</span>
                    <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <ChevronUpIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
            </span>
                </ListboxButton>

                <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                            leave-to-class="opacity-0">
                    <ListboxOptions
                        class="fixed z-10 mt-1 w-full sm:w-48 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                        <ListboxOption as="template" v-for="option in options" :key="option.id" :value="option"
                                       v-slot="{ active, selected }">
                            <li :class="[active ? 'text-white bg-cyan-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-8 pr-4']">
                  <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                    {{ option.name }}
                  </span>

                                <span v-if="selected"
                                      :class="[active ? 'text-white' : 'text-cyan-600', 'absolute inset-y-0 left-0 flex items-center pl-1.5']">
                    <CheckIcon class="h-5 w-5" aria-hidden="true"/>
                  </span>
                            </li>
                        </ListboxOption>
                    </ListboxOptions>
                </transition>
            </div>
        </Listbox>
    </div>

</template>

<script>
import {ref} from 'vue'
import {Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions} from '@headlessui/vue'
import {CheckIcon, ChevronUpIcon} from '@heroicons/vue/20/solid'
import {BarsArrowDownIcon, BarsArrowUpIcon} from "@heroicons/vue/24/outline";

export default {
    props: ['modelValue', 'options'],
    emits: ['update:modelValue'],
    components: {
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CheckIcon,
        ChevronUpIcon,
        BarsArrowUpIcon,
        BarsArrowDownIcon
    },
    setup(props) {
        const selected = ref(props.options.find(p => p.id === props.modelValue.id))
        return {
            selected,
        }
    },
    methods: {},
}
</script>
